import React from 'react';
import './styles.scss';

/**
 * Hexact “Second Brain” desktop app promo for the Hexowatch marketing home page.
 * UTM parameters identify traffic from this site for analytics on brain.hexact.io downloads.
 */
const MAC_HREF =
  'https://brain.hexact.io/api/download/mac?utm_source=hexowatch&utm_medium=referral&utm_campaign=external';
const WINDOWS_HREF =
  'https://brain.hexact.io/api/download/windows?utm_source=hexowatch&utm_medium=referral&utm_campaign=external';

const SecondBrainBanner = () => {
  return (
    <section className="second-brain-banner" aria-labelledby="second-brain-heading">
      <p className="second-brain-banner__eyebrow">Introducing</p>

      <div className="second-brain-banner__logo-row">
        <div className="second-brain-banner__mark" aria-hidden="true">
          {[1, 2, 3, 4, 5].map(i => (
            <span key={i} className="second-brain-banner__mark-bar" />
          ))}
        </div>
        <div className="second-brain-banner__brand">
          <div className="second-brain-banner__brand-main">Hexact</div>
          <div className="second-brain-banner__brand-sub">Second Brain</div>
        </div>
      </div>

      <h2 id="second-brain-heading" className="second-brain-banner__headline">
        Your local AI <span className="second-brain-banner__headline-accent">knowledge base.</span>
      </h2>

      <p className="second-brain-banner__sub">
        Connected to AI. Powered by your real business data. Stop re-explaining your business every conversation.
      </p>

      <div className="second-brain-banner__actions">
        <a
          className="second-brain-banner__btn second-brain-banner__btn--mac"
          href={MAC_HREF}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download for Mac (.dmg)
        </a>
        <a
          className="second-brain-banner__btn second-brain-banner__btn--win"
          href={WINDOWS_HREF}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download for Windows (.exe)
        </a>
      </div>

      <p className="second-brain-banner__fineprint">
        Free to download. 7-day free trial, no credit card required.
        <br />
        Second Brain is a standalone product with its own subscription. Not included in your Hexomatic plan.
      </p>
    </section>
  );
};

export default SecondBrainBanner;
